import Cookies from "js-cookie";

const CookieBar = {
  el: null,
  name: "cookie_legislation_seen",

  init() {
    CookieBar.events();
  },

  events() {
    // Load
    var cookieSet = Cookies.get(CookieBar.name);
    if (typeof cookieSet == "undefined") {
      CookieBar.get();
    }

    // On click set cookie
    $("body").on("click", "#cookies-btn", function (e) {
      e.preventDefault();
      CookieBar.accept();
    });

    // Adjust size
    $(window).on("resize", CookieBar.resize);
  },

  get() {
    $.ajax({
      url: ajaxurl,
      data: {
        action: "cookie_bar",
      },
      type: "POST",
      dataType: "JSON",
    }).done((response) => {
      $(".wrapper").append(response);
      CookieBar.el = $("#cookies");

      setTimeout(function () {
        CookieBar.resize();
        $(CookieBar.el).removeClass("cookies--hidden");
      }, 250);
    });
  },

  resize() {
    if (CookieBar.el) {
      var cookiesBarHeight = $("#cookies").height();
      $(".wrapper").css("padding-bottom", cookiesBarHeight);
    }
  },

  accept() {
    Cookies.set(CookieBar.name, true, {
      expires: 365,
    });

    $(CookieBar.el).addClass("cookies--hidden");
    setTimeout(function () {
      $(".wrapper").css("padding-bottom", 0);
      CookieBar.el.remove();
    }, 250);
  },
};
export default CookieBar;
